define('../app/fukit/view/block/content.actions.header.view',['require','exports','module','underscore','uikit/uikit','../../helpers/extend.util','../../behavior/resolve.route.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                    = require('underscore'),
      UIKit                = require('uikit/uikit'),
      ExtendUtil           = require('../../helpers/extend.util'),
      ResolveRouteBehavior = require('../../behavior/resolve.route.behavior');

  var ActionsView = UIKit.ComponentsContainerView.extend({
    className: 'actions container',

    attributes: {
      style: 'display: inline-block;',
    },

    childView: UIKit.Button.extend({
      behaviors: {
        ResolveRouteBehavior: {
          behaviorClass: ResolveRouteBehavior,
        },
      },
    }),
  });

  var ContentActionsHeaderView = UIKit.ItemView.extend({
    className: 'ui segment content actions',

    template: function() {
      return '<div class="ui middle aligned grid"><div class="column eight wide"><ui name="headerTextView" /><ui name="dropdownView" /></div> <div class="column eight wide right aligned"><ui name="textView" /><ui name="actionsView" /></div></div><ui name="contentView" />';
    },

    ui: {
      gridContainer: '> .ui.grid',
    },

    options: {
      attached: false,
      compact: false,
      disabled: false,
      color: 'blue',
    },

    internalViewOptions: {
      headerTextView: ExtendUtil.extendOptionValueWithDefaults('header', {
        type: UIKit.Header.extend({
          tagName: 'h4',
          attributes: {
            style: 'margin-bottom: 0;',
          },
        }),
      }),
      dropdownView: ExtendUtil.extendOptionValueWithDefaults('dropdown', {
        type: UIKit.Dropdown.extend({
          attributes: {
            style: 'margin-left: 0.5em;',
          },
        }),
        visible: false,
      }),
      textView: ExtendUtil.extendOptionValueWithDefaults('text', {
        type: UIKit.Text.extend({
          attributes: {
            style: 'margin-right: 1em;',
          },
        }),
      }),
      actionsView: ExtendUtil.extendOptionValueWithDefaults('actions', {
        type: ActionsView,
      }),
      contentView: ExtendUtil.extendOptionValueWithDefaults('content', {}),
    },

    updateAttributes: function() {
      var attached = this.getOption('attached');
      this.addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached'));
      this.addClass(this.getOption('color'), this.getBoolOption('color'));
      this.addClass('disabled', this.getBoolOption('disabled'));
      if (this.ui.gridContainer) {
        if (this.getBoolOption('compact')) {
          this.ui.gridContainer.addClass('compact');
        } else {
          this.ui.gridContainer.removeClass('compact');
        }
      }
    },
  });

  module.exports = ContentActionsHeaderView;
});

